import { forwardRef } from 'react';
import { BaseProps } from 'src/modules/shared/types/component.type';
import NumberInput from '../number-input';
import Label from '../label';

interface LabelNumberInputProps extends BaseProps {
  label: string;
  value: number | string;
  onChange: (value: number) => void;
  id?: string;
  name?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  min?: number;
  max?: number;
  step?: number;
  neumorphic?: 'inset-sm' | 'inset' | 'flat' | 'none';
  helperText?: string;
}

const LabelNumberInput = forwardRef<HTMLInputElement, LabelNumberInputProps>(
  (
    {
      label,
      value,
      onChange,
      id,
      name,
      placeholder,
      required = false,
      disabled = false,
      error,
      variant = 'primary',
      size = 'md',
      className = '',
      min,
      max,
      step,
      neumorphic,
      helperText,
    },
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      onChange(value ? Number(value) : 0);
    };

    return (
      <div className={`flex flex-col space-y-1 ${className}`}>
        <Label title={label} required={required}>
          {label}
        </Label>
        <NumberInput
          ref={ref}
          id={id}
          name={name}
          value={value.toString()}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          error={error}
          variant={variant}
          size={size}
          min={min}
          max={max}
          step={step}
          shadow={neumorphic}
        />
        {helperText && !error && (
          <div className="mt-1 text-xs text-secondary-600">{helperText}</div>
        )}
      </div>
    );
  }
);

LabelNumberInput.displayName = 'LabelNumberInput';

export default LabelNumberInput;
